import { Component, Inject, AfterViewInit } from "@angular/core";
import { FormControl, FormGroup, RequiredValidator, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { GetMasterCommercialPurposeGQL } from "../../../../generated/graphql";
export interface DialogData {
  name: String;
  commercial: any;
  type: String;
}

@Component({
  selector: "setting-item-dialog",
  templateUrl: "setting-item-dialog.html",
})
export class SettingItemDialog implements AfterViewInit {
  type: String;
  editNew: String = "New";
  commercialEnum: any;
  itemDialogForm: FormGroup;
  constructor(
    private getMasterCommercialPurposeGQL: GetMasterCommercialPurposeGQL,
    public dialogRef: MatDialogRef<SettingItemDialog>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData
  ) {
    this.itemDialogForm = new FormGroup({
      name: new FormControl("" , [Validators.required]),
      commercial: new FormControl(""),
    });

    if (data.name) {
      this.itemDialogForm.controls.name.setValue(data.name);
      this.editNew = "Edit";
    }
    if (data.commercial) {
      this.itemDialogForm.controls.commercial.setValue(data.commercial);
    }

    this.type = data.type;
    if (this.type == "Property Type") {
      this.itemDialogForm.controls.commercial.setValidators([Validators.required]);
      this.getMasterCommercialPurposeGQL
        .fetch()
        .subscribe(
          (com) =>
            (this.commercialEnum = com.data.GetAllMasterInfo.CommercialPurposes)
        );
    }
  }

  save() {
    if (this.itemDialogForm.valid) {
      if (this.type == "Property Type") {
        this.dialogRef.close({
          name: this.itemDialogForm.controls.name.value,
          commercial: this.itemDialogForm.controls.commercial.value,
        });
      } else {
        this.dialogRef.close(this.itemDialogForm.controls.name.value);
      }
    }
  }

  ngAfterViewInit() {}
}
